import {NavController} from 'ionic-angular';
import {OauthService} from './oauth.service';
import {Config} from './config.service';
import {LoginPage} from '../../pages/login/login';
import {BeneficiaireListPage} from '../../pages/beneficiaire-list/beneficiaire-list';
import {UserBoardPage} from '../../pages/user-board/user-board';
import {UserTempPage} from '../../pages/user-temp/user-temp';
import { UserStorageService } from '.';
import { User } from '../models/user/user.model';

export class AuthService {
  public config = new Config();
  public currentMode;
  public isAllowedMode;

  constructor(
    private allowedMode,
    private navCtrl: NavController,
    private oauthService: OauthService,
    private storage: UserStorageService
  ) {
    this.currentMode = this.config.getConfig('app');
  }

  redirectOut(forceRedirect: any = false) {
    let redirectTo;
    const params = {};
    if (forceRedirect) {
      redirectTo = forceRedirect;
    } else {
      switch (this.currentMode) {
        case 'elu':
          redirectTo = BeneficiaireListPage;
          break;
        case 'salarie':
          // dans le cas d'u n login temporaire, on part sur la page de définition d'email perso
          const userIdentity = this.storage.get() as User;
          if (userIdentity.loginTemporaire) {
            redirectTo = UserTempPage;
          } else {
            redirectTo = UserBoardPage;
          }
          break;
        default:
          break;
      }
    }
    if (redirectTo) {
      setTimeout(() => {
        this.navCtrl.push(redirectTo, params);
      }, 1);
    }
  }

  ionViewCanEnter(page = false): boolean {
    this.isAllowedMode = this.allowedMode.indexOf(this.currentMode) !== -1;
    if (!this.oauthService.userIsLoggedIn()) {
      // User not authorize to access this page!
      this.redirectOut(LoginPage);
      return false;
    }
    if (!this.isAllowedMode) {
      // User not authorize to access this page!
      this.redirectOut(page);
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/auth.service.ts